import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	loadMore: {
		id: 'calendar.calendar-renderer.issues-paginator.load-more',
		defaultMessage: 'Load more',
		description: 'The button label to load more issues into the calendar view',
	},
});
